const hostURL = 'https://mfu.i99.link/';
const baseURL = 'https://mfu-api.aipen.io';
// const baseURL = 'http://localhost:3030';

module.exports = {
  hostURL,
  baseURL,
};
